import React, { useEffect, useState } from "react";
import axios from "axios";
import { Container, Typography, Box } from "@mui/material";

function Windows8App() {
    const [windows8app, setWindows8app] = useState([]);

    useEffect(() => {
        axios
            .get("/files/mobileApps/windows8_app.txt")
            .then((res) => setWindows8app(res.data))
            .catch((err) => console.error(err));
    }, []);

    return (
        <Container maxWidth="lg" sx={{ py: 2 }}>
            {/* Title */}
            <Typography
                variant="h3"
                align="center"
                gutterBottom
                sx={{
                    fontWeight: "bold",
                    color: "#030366",
                    mt: 7,
                    fontSize: {
                        xs: "1.8rem",  // mobile (~h4)
                        sm: "2.2rem",  // tablet (~h3)
                        md: "2.8rem",  // laptop (~h3+)
                        lg: "3rem",    // desktop (~h2)
                    },
                }}
            >
                Windows 8 App Development
            </Typography>

            {/* Content */}
            <Box sx={{ display: "flex", flexDirection: "row" }}>
                <Box sx={{ p: 2, textAlign: "justify" }}>
                    {windows8app &&
                        windows8app.map((data, index) => (
                            <Typography
                                key={index}
                                variant="body1"
                                sx={{ fontSize: "18px", fontFamily: "Raleway, sans-serif", mb: 2 }}
                            >
                                {data}
                            </Typography>
                        ))}
                </Box>
            </Box>
        </Container>
    );
}

export default Windows8App;
